import { SchemaType } from "@latticexyz/schema-type/deprecated";

export const schemaTypesToRecsTypeStrings: Record<SchemaType, string> = {
  [SchemaType.UINT8]: "RecsType.Number",
  [SchemaType.UINT16]: "RecsType.Number",
  [SchemaType.UINT24]: "RecsType.Number",
  [SchemaType.UINT32]: "RecsType.Number",
  [SchemaType.UINT40]: "RecsType.Number",
  [SchemaType.UINT48]: "RecsType.Number",
  [SchemaType.UINT56]: "RecsType.BigInt",
  [SchemaType.UINT64]: "RecsType.BigInt",
  [SchemaType.UINT72]: "RecsType.BigInt",
  [SchemaType.UINT80]: "RecsType.BigInt",
  [SchemaType.UINT88]: "RecsType.BigInt",
  [SchemaType.UINT96]: "RecsType.BigInt",
  [SchemaType.UINT104]: "RecsType.BigInt",
  [SchemaType.UINT112]: "RecsType.BigInt",
  [SchemaType.UINT120]: "RecsType.BigInt",
  [SchemaType.UINT128]: "RecsType.BigInt",
  [SchemaType.UINT136]: "RecsType.BigInt",
  [SchemaType.UINT144]: "RecsType.BigInt",
  [SchemaType.UINT152]: "RecsType.BigInt",
  [SchemaType.UINT160]: "RecsType.BigInt",
  [SchemaType.UINT168]: "RecsType.BigInt",
  [SchemaType.UINT176]: "RecsType.BigInt",
  [SchemaType.UINT184]: "RecsType.BigInt",
  [SchemaType.UINT192]: "RecsType.BigInt",
  [SchemaType.UINT200]: "RecsType.BigInt",
  [SchemaType.UINT208]: "RecsType.BigInt",
  [SchemaType.UINT216]: "RecsType.BigInt",
  [SchemaType.UINT224]: "RecsType.BigInt",
  [SchemaType.UINT232]: "RecsType.BigInt",
  [SchemaType.UINT240]: "RecsType.BigInt",
  [SchemaType.UINT248]: "RecsType.BigInt",
  [SchemaType.UINT256]: "RecsType.BigInt",
  [SchemaType.INT8]: "RecsType.Number",
  [SchemaType.INT16]: "RecsType.Number",
  [SchemaType.INT24]: "RecsType.Number",
  [SchemaType.INT32]: "RecsType.Number",
  [SchemaType.INT40]: "RecsType.Number",
  [SchemaType.INT48]: "RecsType.Number",
  [SchemaType.INT56]: "RecsType.BigInt",
  [SchemaType.INT64]: "RecsType.BigInt",
  [SchemaType.INT72]: "RecsType.BigInt",
  [SchemaType.INT80]: "RecsType.BigInt",
  [SchemaType.INT88]: "RecsType.BigInt",
  [SchemaType.INT96]: "RecsType.BigInt",
  [SchemaType.INT104]: "RecsType.BigInt",
  [SchemaType.INT112]: "RecsType.BigInt",
  [SchemaType.INT120]: "RecsType.BigInt",
  [SchemaType.INT128]: "RecsType.BigInt",
  [SchemaType.INT136]: "RecsType.BigInt",
  [SchemaType.INT144]: "RecsType.BigInt",
  [SchemaType.INT152]: "RecsType.BigInt",
  [SchemaType.INT160]: "RecsType.BigInt",
  [SchemaType.INT168]: "RecsType.BigInt",
  [SchemaType.INT176]: "RecsType.BigInt",
  [SchemaType.INT184]: "RecsType.BigInt",
  [SchemaType.INT192]: "RecsType.BigInt",
  [SchemaType.INT200]: "RecsType.BigInt",
  [SchemaType.INT208]: "RecsType.BigInt",
  [SchemaType.INT216]: "RecsType.BigInt",
  [SchemaType.INT224]: "RecsType.BigInt",
  [SchemaType.INT232]: "RecsType.BigInt",
  [SchemaType.INT240]: "RecsType.BigInt",
  [SchemaType.INT248]: "RecsType.BigInt",
  [SchemaType.INT256]: "RecsType.BigInt",
  [SchemaType.BYTES1]: "RecsType.String",
  [SchemaType.BYTES2]: "RecsType.String",
  [SchemaType.BYTES3]: "RecsType.String",
  [SchemaType.BYTES4]: "RecsType.String",
  [SchemaType.BYTES5]: "RecsType.String",
  [SchemaType.BYTES6]: "RecsType.String",
  [SchemaType.BYTES7]: "RecsType.String",
  [SchemaType.BYTES8]: "RecsType.String",
  [SchemaType.BYTES9]: "RecsType.String",
  [SchemaType.BYTES10]: "RecsType.String",
  [SchemaType.BYTES11]: "RecsType.String",
  [SchemaType.BYTES12]: "RecsType.String",
  [SchemaType.BYTES13]: "RecsType.String",
  [SchemaType.BYTES14]: "RecsType.String",
  [SchemaType.BYTES15]: "RecsType.String",
  [SchemaType.BYTES16]: "RecsType.String",
  [SchemaType.BYTES17]: "RecsType.String",
  [SchemaType.BYTES18]: "RecsType.String",
  [SchemaType.BYTES19]: "RecsType.String",
  [SchemaType.BYTES20]: "RecsType.String",
  [SchemaType.BYTES21]: "RecsType.String",
  [SchemaType.BYTES22]: "RecsType.String",
  [SchemaType.BYTES23]: "RecsType.String",
  [SchemaType.BYTES24]: "RecsType.String",
  [SchemaType.BYTES25]: "RecsType.String",
  [SchemaType.BYTES26]: "RecsType.String",
  [SchemaType.BYTES27]: "RecsType.String",
  [SchemaType.BYTES28]: "RecsType.String",
  [SchemaType.BYTES29]: "RecsType.String",
  [SchemaType.BYTES30]: "RecsType.String",
  [SchemaType.BYTES31]: "RecsType.String",
  [SchemaType.BYTES32]: "RecsType.String",
  [SchemaType.BOOL]: "RecsType.Boolean",
  [SchemaType.ADDRESS]: "RecsType.String",
  [SchemaType.UINT8_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT16_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT24_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT32_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT40_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT48_ARRAY]: "RecsType.NumberArray",
  [SchemaType.UINT56_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT64_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT72_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT80_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT88_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT96_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT104_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT112_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT120_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT128_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT136_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT144_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT152_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT160_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT168_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT176_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT184_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT192_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT200_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT208_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT216_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT224_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT232_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT240_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT248_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.UINT256_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT8_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT16_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT24_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT32_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT40_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT48_ARRAY]: "RecsType.NumberArray",
  [SchemaType.INT56_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT64_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT72_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT80_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT88_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT96_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT104_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT112_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT120_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT128_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT136_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT144_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT152_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT160_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT168_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT176_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT184_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT192_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT200_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT208_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT216_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT224_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT232_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT240_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT248_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.INT256_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES1_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES2_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES3_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES4_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES5_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES6_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES7_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES8_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES9_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES10_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES11_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES12_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES13_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES14_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES15_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES16_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES17_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES18_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES19_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES20_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES21_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES22_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES23_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES24_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES25_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES26_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES27_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES28_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES29_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES30_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES31_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BYTES32_ARRAY]: "RecsType.BigIntArray",
  [SchemaType.BOOL_ARRAY]: "RecsType.T", // no boolean array
  [SchemaType.ADDRESS_ARRAY]: "RecsType.StringArray",
  [SchemaType.BYTES]: "RecsType.String",
  [SchemaType.STRING]: "RecsType.String",
};
